export default "__VITE_ASSET__DRDQY7ZR__"